import React from 'react';
import { Box, Typography, TextField, Button } from '@mui/material';

const OtpVerificationStep = ({
  classes,
  otp,
  setOtp,
  otpDeliveryMethod,
  phone,
  onBack,
  onVerify,
  onSkip,
}) => (
  <Box>
    <form className={classes.form}>
      <Typography variant="body1" style={{ marginBottom: '1rem' }}>
        Enter the OTP sent via {otpDeliveryMethod === 'sms' ? 'SMS' : 'Voice Call'} to {phone}
      </Typography>
      <TextField
        className={classes.formField}
        label="OTP Code"
        value={otp}
        onChange={(e) => setOtp(e.target.value)}
        variant="outlined"
        fullWidth
        placeholder="Enter 6-digit OTP"
      />
      <Box className={classes.buttonContainer}>
        <Button
          variant="outlined"
          onClick={onBack}
        >
          Back
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onVerify}
        >
          Verify OTP
        </Button>
      </Box>
    </form>
    <Box className={classes.skipOtpContainer}>
      <Typography variant="body2" style={{ marginBottom: '0.5rem' }}>
        Having trouble receiving the OTP?
      </Typography>
      <Button
        variant="outlined"
        color="secondary"
        onClick={onSkip}
      >
        Verify with DBIC Instead
      </Button>
    </Box>
  </Box>
);

export default OtpVerificationStep;